import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';
import { FormField } from '../forms/form-field.model';

@Component({
  selector: 'app-send-email-dialog',
  templateUrl: './send-email-dialog.component.html',
  styleUrls: ['./send-email-dialog.component.scss']
})
export class SendEmailDialogComponent implements OnInit {

  button: string;
  field: FormField;
  recipients: any[];
  title: string;
  workflowId: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.button = this.data.button != null ? this.data.button : "Send";
    this.title = this.data.title != null ? this.data.title : "Send email to:";
    this.recipients = this.data.recipients != null ? this.data.recipients : [];
    this.workflowId = this.data.workflowId;

    this.field = new FormField();
    this.field.label = "Recipients";
  }

  onValueChange(event) {
    this.recipients = event.value;
  }

  onClose() {
    let emails: string[] = [];
    for (let r of this.recipients) {
      r = r.stored
      if (r.users != null) {
        // Distribution list
        for (let u of r.users) {
          emails.push(u.email);
        }
      } else {
        emails.push(r.email);
      }
    }
    return {recipients: emails}
  }

}


// WEBPACK FOOTER //
// ./src/app/transfers/send-email-dialog.component.ts